"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRange = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const styled_1 = require("@datepicker-react/styled");
const styled_components_1 = require("styled-components");
const dateRange_style_1 = __importDefault(require("./dateRange.style"));
const initialState = {
    startDate: null,
    endDate: null,
    focusedInput: null
};
function reducer(state, action) {
    switch (action.type) {
        case 'focusChange':
            return { ...state, focusedInput: action.payload };
        case 'dateChange':
            return action.payload;
        default:
            throw new Error();
    }
}
const DateRange = ({ classes, showResetDates, showClose, showSelectedDates, numberOfMonths, onValueChange, placement }) => {
    const [state, dispatch] = react_1.useReducer(reducer, initialState);
    const { startDate, endDate, focusedInput } = state;
    const handleOnDatesChange = data => {
        dispatch({ type: 'dateChange', payload: data });
        onValueChange(data);
    };
    const handleOnFocusChange = input => {
        dispatch({ type: 'focusChange', payload: input });
    };
    return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root }, { children: [jsx_runtime_1.jsxs("ul", Object.assign({ className: "prefix" }, { children: [jsx_runtime_1.jsx("li", { children: "From" }, void 0),
                    jsx_runtime_1.jsx("li", {}, void 0),
                    jsx_runtime_1.jsx("li", { children: "To" }, void 0)] }), void 0),
            jsx_runtime_1.jsx(styled_components_1.ThemeProvider, Object.assign({ theme: {
                    breakpoints: ['32em', '48em', '64em'],
                    reactDatepicker: {
                        daySize: [36, 36],
                        fontFamily: 'EuclidCircularB, system-ui, -apple-system',
                        colors: {
                            primaryColor: '#4B35D2',
                            accessibility: '#4B35D2',
                            selectedDay: '#EEEDFD',
                            selectedDayHover: '#faf9fd',
                            normalDayHover: '#faf9fd'
                        },
                        dayLabelFontSize: 10,
                        dayLabelColor: '#8F8B9B',
                        selectDateLabelFontSize: 10,
                        selectDateLabelColor: '#D0CED5',
                        selectDateDateFontSize: 14,
                        selectDateDateColor: '#34323A',
                        selectDateBorderColor: '#4B35D2',
                        navButtonBorder: 'none',
                        monthLabelFontSize: 16,
                        monthLabelFontWeight: 600,
                        dayBackground: '#ffffff',
                        dayBorderColor: 'transparent',
                        dayColor: '#34323A',
                        dayFontSize: 15,
                        daySelectedBorderColor: 'transparent',
                        daySelectedColor: '#34323A',
                        daySelectedHoverColor: '#000000',
                        dayHoverColor: '#000000',
                        dayHoverBackground: '#EEEDFD',
                        // dayHoverRangeColor: "#000000", // be carefull here
                        dayHoverRangeBackground: '#EEEDFD',
                        dayAccessibilityBorderColor: 'none',
                        inputLabelDisplay: 'flex',
                        inputLabelBorder: 'none',
                        inputLabelMargin: 0,
                        inputPadding: 0,
                        inputBorder: 'none',
                        inputFontSize: 14,
                        inputColor: '#34323A',
                        inputActiveBoxShadow: 'none',
                        inputLabelBackground: 'transparent',
                        inputBackground: 'none',
                        datepickerZIndex: 1,
                        datepickerBoxShadow: '0px 5px 15px #28128733',
                        datepickerBorderRadius: 5,
                        datepickerPadding: 25,
                        datepickerPosition: 'absolute',
                        datepickerMonthsGridGap: 10,
                        dateRangeBorder: 'none',
                        dateRangeArrowIconColor: '#34323A',
                        dateRangeStartDateInputPadding: 0,
                        dateRangeEndDateInputPadding: 0,
                        dateRangeDatepickerWrapperLeft: placement === 'right' ? -170 : 30,
                        dateRangeDatepickerWrapperTop: 77
                    }
                } }, { children: jsx_runtime_1.jsx(styled_1.DateRangeInput, { onDatesChange: handleOnDatesChange, onFocusChange: handleOnFocusChange, displayFormat: "MMM d, y", startDate: startDate, endDate: endDate, focusedInput: focusedInput, showClose: showClose, showResetDates: showResetDates, showStartDateCalendarIcon: false, showEndDateCalendarIcon: false, showSelectedDates: showSelectedDates, onClose: () => { }, numberOfMonths: numberOfMonths }, void 0) }), void 0)] }), void 0));
};
exports.DateRange = DateRange;
exports.DateRange.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onValueChange: prop_types_1.default.func.isRequired,
    showResetDates: prop_types_1.default.bool,
    showClose: prop_types_1.default.bool,
    showSelectedDates: prop_types_1.default.bool,
    numberOfMonths: prop_types_1.default.number,
    placement: prop_types_1.default.oneOf(['left', 'right'])
};
exports.DateRange.defaultProps = {
    showResetDates: true,
    showClose: true,
    showSelectedDates: true,
    numberOfMonths: 2,
    placement: 'left'
};
exports.default = react_jss_1.default(dateRange_style_1.default)(exports.DateRange);
//# sourceMappingURL=dateRange.js.map